import { useGetData } from "@/hooks/useGetData";
import React, { createContext, useEffect, useMemo, useState } from "react";
import {
  filterOrganizationsForUser,
  userHasOrgAssignmentAll,
} from "./use-auth";
import { useAuth } from "./use-auth";

type Orgcontext = {
  organizations: any[];
  selectedOrgId: string | null;
  setSelectedOrgId: (orgId: string | null) => void;
  setOrganizations: (orgs: any[]) => void;
  facilities : any[];
  allFacilities: any[];
  isAllSelected: boolean;
  orgLoading : boolean;
  orgError : any,
  refetchOrg : ()=> void,
  selectedOrganizations: any[],
  resetOrgs : ()=> void
  // allPractitioners : any,
  //  setAllPractitioners : (  prac: any[] )=> void
};

const fac1 = [
       
        {
    _id: "f2",
    organizationId: "anthro-care-clinic",
    name: "Main Inpatient Ward",
    address: "123 Health St",
    city: "New York",
    state: "NY",
    pocName: "Ward Supervisor",
    pocPhone: "555-0600",
    isOutpatients: false,
  },
  {
    _id: "f3",
    organizationId: "anthro-care-clinic",
    name: "Outpatient Services",
    address: "456 Care Ave",
    city: "New York",
    state: "NY",
    pocName: "",
    pocPhone: "",
    isOutpatients: true,
  },
      ]
      const fac2= [
        {
    _id: "f1",
    organizationId: "clinic-123",
    name: "Emergency Department",
    address: "789 Emergency Rd",
    city: "Boston",
    state: "MA",
    pocName: "Emergency Coordinator",
    pocPhone: "555-0700",
    isOutpatients: false,
  },
  {
    _id: "f4",
    organizationId: "clinic-123",
    name: "General Practice",
    address: "101 Community Ln",
    city: "Los Angeles",
    state: "CA",
    pocName: "Practice Manager",
    pocPhone: "555-0800",
    isOutpatients: true,
  }
        
      ]

const OrgContext = createContext<Orgcontext | null>(null);

export default function OrgContextProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const { isAuthenticated, user } = useAuth();
  const [allOrganizations, setAllOrganizations] = useState<any[]>([]);

  const [selectedOrgId, setSelectedOrgId] = useState<string | null>(null);

  const organizations = useMemo(
    () => filterOrganizationsForUser(allOrganizations, user),
    [allOrganizations, user],
  );

  const isAllSelected = selectedOrgId === "anthro-care";
  const allFacilities = (organizations && Array.isArray(organizations) ? organizations.map(o=> o.facilities).flat() : []);
  const facilities  = isAllSelected ? allFacilities : (organizations?.find(o=> o?._id == selectedOrgId)?.facilities || []);
  const selectedOrganizations = isAllSelected ? organizations: organizations.filter(org=> org._id == selectedOrgId);

 

  const {loading : orgLoading, err : orgError, fetchData : refetchOrg} =  useGetData("/organizations", { limit: 30 }, false, isAuthenticated, (err, data) => {
    if (!err && data?.data?.organizations?.length>0) {
      setAllOrganizations(data.data.organizations);
    }
  });

  useEffect(() => {
    if (!organizations.length || selectedOrgId) return;
    if (user?.role === "admin" && userHasOrgAssignmentAll(user)) return;
    setSelectedOrgId(organizations[0]._id);
  }, [organizations, selectedOrgId, user?.role]);

  useEffect(()=> {
    if(organizations && Array.isArray(organizations) && organizations.length>0 && !organizations?.[0]?.facilities){
      setAllOrganizations((prev) =>
        prev.map((org, idx) => ({
          ...org,
          facilities: (idx % 2 ? fac1 : fac2).map((fac) => ({
            ...fac,
            organizationId: org?._id,
          })),
        })),
      );
    }
  },[organizations])
  function resetOrgs(){
    setSelectedOrgId(null);
    setAllOrganizations([]);
  }

  
  return (
    <OrgContext.Provider
      value={{
        orgLoading,
         orgError, 
         refetchOrg,
        organizations,
        setOrganizations: setAllOrganizations,
        selectedOrganizations,
        selectedOrgId,
        setSelectedOrgId,
        facilities ,
        allFacilities,
        isAllSelected,
        resetOrgs,
      }}
    >
      {children}
    </OrgContext.Provider>
  );
}

export const useOrg = () => {
  const context = React.useContext(OrgContext);
  if (!context) {
    throw new Error("useOrg must be used within an OrgContextProvider");
  }
  return context;
};
